import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";

const MegaMenu = () => {
  const businessCode = localStorage.getItem("businessCode");
  const businessName = localStorage.getItem("businessName");

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleCloseDropdown = () => {
    setIsDropdownOpen(false);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <div>
      <NavBar
        toggleDropdown={toggleDropdown}
        isDropdownOpen={isDropdownOpen}
        businessCode={businessCode}
        businessName={businessName}
        handleCloseDropdown={handleCloseDropdown}
      />
    </div>
  );
};

const NavBar = ({
  toggleDropdown,
  isDropdownOpen,
  businessCode,
  businessName,
  handleCloseDropdown,
}) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    navigate("/");
  };

  return (
    <nav className="bg-white border-gray-200 dark:border-gray-600 dark:bg-gray-900">
      <div className="flex flex-wrap justify-between items-center mx-auto max-w-screen-xl p-4">
        <Link
          to="/home"
          className="flex items-center space-x-3 rtl:space-x-reverse"
        >
          <img src={`/img/${businessName}.png`} className="h-8" alt="Logo" />
          <span className="self-center text-2xl font-semibold whitespace-nowrap dark:text-white">
            {businessName}
          </span>
        </Link>
        <button
          data-collapse-toggle="mega-menu-full"
          type="button"
          className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
          aria-controls="mega-menu-full"
          aria-expanded="false"
        >
          <span className="sr-only">Open main menu</span>
          <svg
            className="w-5 h-5"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 17 14"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M1 1h15M1 7h15M1 13h15"
            />
          </svg>
        </button>
        <div
          id="mega-menu-full"
          className="items-center justify-between font-medium hidden w-full md:flex md:w-auto md:order-1"
        >
          <ul className="flex flex-col p-4 md:p-0 mt-4 border border-gray-100 rounded-lg bg-gray-50 md:space-x-8 rtl:space-x-reverse md:flex-row md:mt-0 md:border-0 md:bg-white dark:bg-gray-800 md:dark:bg-gray-900 dark:border-gray-700">
            <li>
              <Link
                to="/home"
                className="block py-2 px-3 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:hover:text-blue-700 md:p-0 dark:text-white md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-blue-500 md:dark:hover:bg-transparent dark:border-gray-700"
                aria-current="page"
              >
                Home
              </Link>
            </li>
            <li>
              <button
                id="mega-menu-full-dropdown-button"
                onClick={toggleDropdown}
                className="flex items-center justify-between w-full py-2 px-2 text-gray-900 rounded md:w-auto hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-600 md:p-0 dark:text-white md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-blue-500 md:dark:hover:bg-transparent dark:border-gray-700"
              >
                Report
                <svg
                  className="w-2.5 h-2.5 ms-2.5"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 10 6"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M1 1l4 4 4-4"
                  />
                </svg>
              </button>
            </li>
            <div class="flex md:order-2 space-x-3 md:space-x-0 rtl:space-x-reverse">
              <button
                type="button"
                class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                onClick={handleLogout}
              >
                Logout
              </button>
              <button
                data-collapse-toggle="navbar-sticky"
                type="button"
                class="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
                aria-controls="navbar-sticky"
                aria-expanded="false"
              >
                <span class="sr-only">Open main menu</span>
                <svg
                  class="w-5 h-5"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 17 14"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M1 1h15M1 7h15M1 13h15"
                  />
                </svg>
              </button>
            </div>
          </ul>
        </div>
      </div>

      <div
        id="mega-menu-full-dropdown"
        className={`${
          isDropdownOpen ? "" : "hidden"
        } mt-1 border-gray-200 shadow-sm bg-gray-50 md:bg-white border-y dark:bg-gray-800 dark:border-gray-600`}
      >
        <div className="grid max-w-screen-xl px-4 py-5 mx-auto text-gray-900 dark:text-white md:px-6">
          <ul className="grid grid-cols-2 auto-rows-fr">
            <li>
              <Link to="/reportcash" onClick={handleCloseDropdown}>
                <a className="block p-3 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700">
                  <div className="font-semibold">Report Cash</div>
                  <span className="text-sm text-gray-500 dark:text-gray-400">
                    Laporan kas
                  </span>
                </a>
              </Link>
            </li>
            <li>
              <Link to="/reportbank" onClick={handleCloseDropdown}>
                <a className="block p-3 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700">
                  <div className="font-semibold">Report Bank</div>
                  <span className="text-sm text-gray-500 dark:text-gray-400">
                    Laporan bank
                  </span>
                </a>
              </Link>
            </li>
            <li>
              <Link to="/reportsales" onClick={handleCloseDropdown}>
                <a className="block p-3 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700">
                  <div className="font-semibold">Report Sales Detail</div>
                  <span className="text-sm text-gray-500 dark:text-gray-400">
                    Laporan penjualan detail
                  </span>
                </a>
              </Link>
            </li>
            <li>
              <Link to="/reportdaily" onClick={handleCloseDropdown}>
                <a className="block p-3 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700">
                  <div className="font-semibold">Report Daily Sales</div>
                  <span className="text-sm text-gray-500 dark:text-gray-400">
                    Laporan Daily Sales
                  </span>
                </a>
              </Link>
            </li>
            <li>
              <Link to="/reportcustomerdetail" onClick={handleCloseDropdown}>
                <a className="block p-3 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700">
                  <div className="font-semibold">Report Sales by Unit</div>
                  <span className="text-sm text-gray-500 dark:text-gray-400">
                    Laporan Penjualan Unit
                  </span>
                </a>
              </Link>
            </li>
            <li>
              <Link to="/reportpl" onClick={handleCloseDropdown}>
                <a className="block p-3 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700">
                  <div className="font-semibold">Report Profit and Loss</div>
                  <span className="text-sm text-gray-500 dark:text-gray-400">
                    Laporan car profit loss unit
                  </span>
                </a>
              </Link>
            </li>
            .
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default MegaMenu;
